const mutations = {
  'SET_SIMILAR_TRAVELERS' (state, { allSimilarTravelers }) {
    state.allSimilarTravelers = allSimilarTravelers
  },
  'SET_SIMILAR_TRAVELER' (state, { similarTravelerDetail }) {
    state.similarTravelerDetail = similarTravelerDetail
  }
}
export default mutations
